import { render, staticRenderFns } from "./demonstrate.vue?vue&type=template&id=5e467190&scoped=true&"
import script from "./demonstrate.vue?vue&type=script&lang=js&"
export * from "./demonstrate.vue?vue&type=script&lang=js&"
import style0 from "./demonstrate.vue?vue&type=style&index=0&id=5e467190&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e467190",
  null
  
)

export default component.exports